import React, { useState, useEffect } from "react";
import Header from "../../Shared/Components/Header/Header";
import Cards from "../../Shared/Components/Cards/Cards";
import Spinner from "../../Shared/Components/Spinner/Spinner";
import { sessionService } from "../../Shared/Utils/SessionService";
import { CONSTANTS, ICON_DETAILS } from "../../Environments/constants";
import { ServiceUtils } from "../../../src/Shared/Utils/ServiceUtils";
import { alertService } from "../../../src/Shared/Utils/ToasterUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faMagnifyingGlass,
    faTable,
    faTableList,
    faCircleArrowLeft
} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import { searchTable, getCountPercent } from "../../Shared/Utils/CommonUtils";
import classNames from "classnames";
import StateListingTable from "./StateListingTable";
import SVGIcon from "../../../src/Shared/Components/SVGIcon/SVGIcon";
import TopNav from "../../Shared/Components/Tabs/TabContainer";
import ComplaintDetails from "../ComplaintDetails/ComplaintDetails";
import {
    Col,
    Row,
    Affix,
    Input,
    Tabs,
    Table,
    Radio,
} from "antd";
import "./StateHomePage.scss";
import RoHomePage from "../RoHomePage/RoHomePage";
const { TabPane } = Tabs;

const MenuConfig = [
    {
        key: "dashboard",
        value: "Dashboard",
    },
    {
        key: "inbox",
        value: "Inbox",
    },
];


const tabPaneValues = [
    {
        key: "open",
        tab: "Received",
    },
    {
        key: "in_progress",
        tab: "In Progress",
    },
    {
        key: "resolved",
        tab: "Resolved",
    },
    {
        key: "returned_to_state",
        tab: "Received from RO",
    },
];

const TableHeader = [
    {
        title: "Sl No",
        dataIndex: "slno",
        key: "slno",
    },
    {
        title: "Assigned RO",
        dataIndex: "ro",
        key: "ro",
    },
    {
        title: "Received by authority",
        dataIndex: "Received",
        key: "received",
    },
    {
        title: "In Progress",
        dataIndex: "In Progress",
        key: "in_progress",
    },
    {
        title: "Resolved by authority",
        dataIndex: "Resolved",
        key: "resolved",
    },
    {
        title: "Escalated to higher official",
        dataIndex: "Escalated",
        key: "escalated",
    },
];

export default function StateHomePage(props) {
    const [cardsList, setCardsList] = useState();
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [complaintsStatus, setComplaintsStatus] = useState();
    const [selectedRO, setSelectedRO] = useState();
    const [searchName, setSearchName] = useState("");
    const [selectedState, setSelectedState] = useState();
    const [selectedCard, setSelectedCard] = useState();
    const [selectedItem, setSelectedItem] = useState("")
    const [view, setView] = useState("Card");
    const [dataSource, setDataSource] = useState([]);
    const [selectedView, setselectedView] = useState("dashboard");
    const [activeTabKey, setActiveTabKey] = useState("open");
    const [inboxTableContent, setInboxTableContent] = useState();
    const [filteredCardsList, setFilteredCardsList] = useState(null);
    const [tableData, setTableData] = useState();
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        setActiveTabKey("open");
        // inboxContentHandler("open");
        onfetchComplaintsStatus(props.selectedEnterprise);
        fetchRoList(props.selectedEnterprise);
    }, []);

    useEffect(() => {
        setFilteredCardsList(cardsList);
        const filteredCards = cardsList?.filter((item) =>
            item.title.toLowerCase().includes(searchName.toLowerCase())
        );
        if (filteredCards?.length > 0) setFilteredCardsList(filteredCards);
        else {
            setFilteredCardsList([]);
        }
        console.log(cardsList);
    }, [searchName, cardsList]);

    const getSelectedItem = (item) => {
        setSelectedItem(item);
    };

    const inboxContentHandler = (e) => {
        setActiveTabKey(e);
        const userDetails = sessionService.getSession("cpcb-user");
        let payload;
        if (userDetails) {
            payload = {
                user_id: userDetails.user_id,
                user_type: userDetails.role[0],
                status: e,
            };
            setIsPageLoading(true);
            const encodedPayload = btoa(JSON.stringify(payload));
            ServiceUtils.postRequest("list-inbox", encodedPayload).then(
                (_response) => {
                    let decodedData;
                    if (_response?.data) {
                        decodedData = JSON.parse(atob(_response.data));
                        console.log("complaints_inbox");
                        console.log(decodedData?.complaint_json);
                    }
                    if (_response.status === 200) {
                        if (
                            decodedData?.status === "failed" ||
                            decodedData?.status === "Failed"
                        ) {
                            alertService.error(
                                decodedData?.message || `Error while listing complaints`
                            );
                        } else {
                            setInboxTableContent(decodedData?.complaint_json);
                            setIsPageLoading(false);
                        }
                    } else {
                        alertService.error(
                            decodedData?.data?.message ||
                            decodedData?.message ||
                            "Internal Server Error"
                        );
                    }
                }
            );
        }
    };
    const handleSelectedView = (view) => {
        setselectedView(view);
        if (view === "inbox") {
            inboxContentHandler("open");
        }
    };

    const statuslist =
        complaintsStatus?.count_json && Object.keys(complaintsStatus?.count_json);

    const onClickRoCard = (item) => {
        if (item.type === "ulb") {
            setSelectedState(item?.title);
        }
        if (item.key !== "returned_to_state") {
            setSelectedRO(item);
        }
    };

    const onClickDashboard = () => {
        setSelectedRO("");
    };

    const createDataSource = (data) => {
        let arr = [];
        data?.map((el, idx) => {
            arr.push({
                key: el.key,
                slno: idx + 1,
                ro: el.title,
            });
            el?.content?.forEach((item) => {
                arr[idx] = { ...arr[idx], [item?.label]: item.count };
            });
        });
        return arr;
    };

    const onfetchComplaintsStatus = (item) => {
        const userDetails = sessionService.getSession("cpcb-user");
        let payload;
        if (userDetails)
            payload = {
                // "tab_name": CONSTANTS[selectedCard],
                user_id: userDetails.user_id,
                user_type: userDetails.role[0],
                state_id: item?.key,
            };

        const encodedPayload = btoa(JSON.stringify(payload));
        ServiceUtils.postRequest("complaints-status", encodedPayload).then(
            (_response) => {
                let decodedData;
                if (_response?.data) {
                    decodedData = JSON.parse(atob(_response.data));
                }

                if (_response.status === 200) {
                    // if (decodedData?.status === 'success') {
                    setComplaintsStatus(decodedData);
                    // } else {
                    //     alertService.error(decodedData?.message || `Error while complaints status`);
                    // }
                } else {
                    alertService.error(
                        decodedData?.data?.message ||
                        decodedData?.message ||
                        "Internal Server Error"
                    );
                }
            }
        );
    };

    const onFilterByName = (event) => {
        setSearchName(event.target.value);
    };

    const fetchRoList = (item) => {
        const userDetails = sessionService.getSession("cpcb-user");
        let payload;
        if (userDetails)
            payload = {
                user_id: userDetails.user_id,
                state_id: item?.key,
            };
        setIsPageLoading(true);
        const encodedPayload = btoa(JSON.stringify(payload));
        ServiceUtils.postRequest("list-cards", encodedPayload).then((_response) => {
            let decodedData;

            if (_response?.data) {
                decodedData = JSON.parse(atob(_response.data));
            }
            if (_response.status === 200) {
                if (
                    decodedData?.status === "failed" ||
                    decodedData?.status === "Failed"
                ) {
                    alertService.error(
                        decodedData?.message || `Error while listing RO's`
                    );
                } else {
                    setIsPageLoading(false);
                    setCardsList(decodedData);
                    const data = createDataSource(decodedData);
                    setDataSource(data);
                    setTableData(data);
                }
            } else {
                alertService.error(
                    decodedData?.data?.message ||
                    decodedData?.message ||
                    "Internal Server Error"
                );
            }
        });
    };

    const searchData = (e) => {
        setSearchText(e.target.value);
        let searchResultData = searchTable(e.target.value, dataSource, TableHeader);
        setTableData(searchResultData);
    };

    return (
        <div>
            {!selectedItem ? <>
                {!selectedRO ? (
                    <>
                        <Header />
                        <Affix offsetTop={45}>
                            {!props.selectedEnterprise ? (
                                <div className="tabsContainer">
                                    <TopNav
                                        menuConfig={MenuConfig}
                                        currentMenu={selectedView}
                                        onAction={handleSelectedView}
                                    />
                                </div>
                            ) : (
                                <>
                                    <div className="breadCrumb">
                                        <div className="path-display-container">
                                            {selectedView === "inbox" ?
                                                <div className="backIcon"
                                                    onClick={() => { setselectedView("dashboard") }}>
                                                    <FontAwesomeIcon
                                                        icon={faCircleArrowLeft}
                                                    />
                                                </div>
                                                :
                                                <div className="backIcon"
                                                    onClick={props.onClickAdminDashboard}>
                                                    <FontAwesomeIcon
                                                        icon={faCircleArrowLeft}
                                                    />
                                                </div>

                                            }
                                            <div
                                                className="breadCrumbLink"
                                                onClick={props.onClickAdminDashboard}
                                            >
                                                Dashboard
                                            </div>
                                            <div>/</div>
                                            <div className="breadCrumbContent">
                                                {props.selectedEnterprise.title}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </Affix>
                        {isPageLoading ? (
                            <Spinner />
                        ) : (
                            <>
                                {selectedView === "dashboard" ? (
                                    <div className="contentDetails">
                                        <div className="selectedCard">{`Total Complaints: ${complaintsStatus?.count_json["total_complaints"]}`}</div>
                                        <Row gutter={6}>
                                            {statuslist?.map((item) => {
                                                if (item !== "total_complaints")
                                                    return (
                                                        <Col onClick={() => { }}>
                                                            <Cards
                                                                icon={
                                                                    <div className={classNames("cardIcon")}>
                                                                        <SVGIcon
                                                                            icon={
                                                                                selectedCard !== CONSTANTS[item]
                                                                                    ? ICON_DETAILS[item]
                                                                                    : `${ICON_DETAILS[item]}Light`
                                                                            }
                                                                        />
                                                                    </div>
                                                                    // <FontAwesomeIcon
                                                                    //     icon={ICON_DETAILS[item]}
                                                                    //     className="iconStyle"
                                                                    // />
                                                                }
                                                                count={complaintsStatus?.count_json[
                                                                    item
                                                                ].toString()}
                                                                content={CONSTANTS[item]}
                                                                selectedCard={selectedCard}
                                                                borderStyle={
                                                                    selectedCard === CONSTANTS[item]
                                                                        ? {
                                                                            borderColor: "#006988",
                                                                            backgroundColor: "#EBF5F8",
                                                                        }
                                                                        : ""
                                                                }
                                                            />
                                                        </Col>
                                                    );
                                            })}
                                        </Row>
                                        <div className="selectedCard ">
                                            <div>
                                                {selectedRO
                                                    ? `Total ULB's under ${selectedRO.title}`
                                                    : "Total RO's"}
                                                {/* {`Total ${selectedCard?.replace("_", " ")}`} */}
                                            </div>
                                            <div className="search-bar">
                                                <div>
                                                    <div className="filter-label">Filter by Name:</div>
                                                    <Input
                                                        placeholder="Search by name"
                                                        className="text-field"
                                                        value={searchText}
                                                        onChange={(e) => {
                                                            onFilterByName(e);
                                                            searchData(e);
                                                        }}
                                                    />
                                                </div>
                                                {/* {view === "Table" &&
                                                <Tooltip title="Download report as CSV file">
                                                    <Button type="primary" icon={<DownloadOutlined />} size="default" className="downloadCSV" onClick={() => tableToCSV("ulb_report")} />
                                                </Tooltip>
                                            } */}
                                                <div>
                                                    <Radio.Group buttonStyle="solid" value={view}>
                                                        <Radio.Button
                                                            value="Card"
                                                            onClick={() => {
                                                                setView("Card");
                                                            }}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faTable}
                                                                className="dashboard-svg-icon grid-icon"
                                                            />
                                                            {/* <SVGIcon
                                                        className="dashboard-svg-icon grid-icon"
                                                        icon={"gridView"}
                                                    /> */}
                                                        </Radio.Button>
                                                        <Radio.Button
                                                            value="Table"
                                                            onClick={() => {
                                                                setView("Table");
                                                            }}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faTableList}
                                                                className="dashboard-svg-icon grid-icon"
                                                            />
                                                            {/* <SVGIcon
                                                        className="dashboard-svg-icon table-icon"
                                                        icon={"tableView"}
                                                    /> */}
                                                        </Radio.Button>
                                                    </Radio.Group>
                                                </div>
                                            </div>
                                        </div>
                                        {view === "Card" ? (
                                            <Row gutter={6}>
                                                {filteredCardsList?.length > 0 ? (
                                                    <>
                                                        {(filteredCardsList || cardsList)?.map((item) => {
                                                            const titleSection = <>
                                                            <div>{`${item?.title} : ${item?.total_count && item?.total_count}`}</div>
                                                            <div>{`Resolved count : ${item?.resolved_count && item?.resolved_count}`}</div>
                                                            </>
                                                            return (
                                                                <Col
                                                                    onClick={() => {
                                                                        onClickRoCard(item);
                                                                    }}
                                                                >
                                                                    <Cards
                                                                        title={titleSection}
                                                                        headStyle={getCountPercent(item?.content) ? { backgroundColor: "#FF0000" } : { backgroundColor: "#0082A0" }}
                                                                        data={item?.content}
                                                                        borderStyle={{ cursor: "pointer" }}
                                                                    />
                                                                </Col>
                                                            );
                                                        })}
                                                    </>
                                                ) : (
                                                    <div className="no-results">
                                                        <div>
                                                            <FontAwesomeIcon
                                                                icon={faMagnifyingGlass}
                                                                className="search-icon"
                                                            />
                                                        </div>
                                                        <div className="no-results-label">
                                                            Sorry, no results found
                                                        </div>
                                                    </div>
                                                )}
                                            </Row>
                                        ) : (
                                            <Row className="dashboard-table-container">
                                                <Col span="24">
                                                    <Table
                                                        className="table"
                                                        rowKey="key"
                                                        columns={TableHeader}
                                                        dataSource={tableData}
                                                        pagination={true}
                                                        scroll={{
                                                            x: 1300,
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        )}
                                    </div>
                                ) : (
                                    <div className="inbox-container">
                                        <Tabs
                                            className="button-container"
                                            type="card"
                                            size="small"
                                            activeKey={activeTabKey}
                                            onChange={inboxContentHandler}
                                        >
                                            {tabPaneValues.map((el) => {
                                                return (
                                                    <TabPane
                                                        className="table-container"
                                                        tab={el.tab}
                                                        key={el.key}
                                                    >
                                                        <StateListingTable dataValues={inboxTableContent} getSelectedItem={getSelectedItem} />
                                                    </TabPane>
                                                );
                                            })}
                                        </Tabs>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                ) : (
                    <RoHomePage
                        onClickAdminDashboard={props.onClickAdminDashboard}
                        onClickStateDashboard={onClickDashboard}
                        selectedState={props.selectedEnterprise}
                        selectedEnterprise={selectedRO}
                    />
                )}
            </> :
                <ComplaintDetails
                    currentComplaintId={selectedItem}
                    onClickStateDashboard={() => setSelectedItem("")}
                    onClickBack={() => setSelectedItem("")}
                />}
        </div>
    );
}
